export default String.raw`
.header-top-banner {
    display: flex;
    justify-content: center;
    padding: 16px 9%;
    text-align: center;
    background: $topBannerBgColor;
    color: $topBannerFontColor;
    transition: all ease 300ms;

    &:hover {
        color: $topBannerFontHoverColor;
    }

    &__content {
        box-sizing: border-box;
        display: flex;
        width: 100%;
        font-size: clamp(12px, 2vw, 14px);
        font-weight: 500;
        line-height: clamp(20px, 3vw, 24px);
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 5%;

        &--links {
            .header-top-banner__text-wrapper {
                display: flex;
                flex: 1 1 clamp(30%, 50%, 75%);
                flex-wrap: wrap;
                align-items: baseline;
                gap: 4px;
            }

            .swiper-wrapper {
                justify-content: space-between;
            }

            .swiper-slide {
                width: auto;
            }

            .header-top-banner__text {
                display: block;
            }
        }

        &--justify {
            .header-top-banner__link-wrapper {
                flex: unset;

                &:first-child {
                    margin-left: unset;
                }
            }
        }
    }

    &__text {
        display: flex;
        flex-direction: column;
        gap: 4px;
        justify-content: center;
        align-items: center;
        line-height: clamp(20px, 3vw, 24px);
        margin: 0;
    }

    &__link {
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        justify-content: flex-end;
        word-break: break-word;
        font-weight: 500 !important;
        color: $topBannerFontColor;

        &:focus-visible {
            outline-offset: -1px !important;
        }

        &:hover {
            color: $topBannerFontHoverColor;
            text-decoration: underline;
        }

        &-wrapper {
            flex: 1 0 auto;
            max-width: 15%;

            &:first-child {
                padding-left: 0;
                margin-left: auto;
            }

            &:last-child {
                padding-right: 0;
            }
        }
    }

    &__countdown-timer {
        font-weight: 600;
        line-height: 24px;
        margin: 0;
        padding: 0;
        font-size: clamp(16px, 2.5vw, 18px);
        transition: visibility 0s, opacity 0.5s ease-in;
    }

    a.header-top-banner__content {
        width: fit-content;
        color: $topBannerFontColor;

        &:hover {
            color: $topBannerFontHoverColor;
        }
    }
}

.header-top-bar {
    width: 100%;
    background: $bgColor;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 130px;
    border-bottom: 1px solid #E7E7E7;
    button {
        border: none;
        line-height: 1;
        cursor: pointer;
    }
    &__side {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        & > * {
            margin-right: 16px;
            &:last-child {
                margin-right: 0;
            }
        }
        &:last-child {
            justify-content: flex-end;
            margin-left: auto;
        }
    }
    &__info {
        display: flex;
        align-items: center;
        color: $primaryColorFont;
        font-weight: 500;
        transition: all ease 300ms;
        &-icon {
            fill: $primaryColorFont;
            margin-right: 4px;
            transition: all ease 300ms;
        }
        &:hover {
            color: $hoverOverButton;
            .header-top-bar__info-icon {
                fill: $hoverOverButton;
            }
        }
    }
    &__company {
        position: relative;
        margin-right: 32px;
        &-name {
            max-width: 300px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            & + .header__btn-icon {
                margin-left: 4px;
                margin-right: 0;
                padding: 2px;
            }
        }
        &-search {
            display: flex;
            align-items: center;
            border-radius: 5px;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.20);
            background: $inputsBgColor;
            margin: 0 8px 4px;
            input {
                border: none;
                color: #767676;
                width: 196px;
            }
            .header__btn-icon {
                fill: #767676;
                cursor: pointer;
            }
        }
        &-list {
            display: flex;
            flex-direction: column;
            max-height: 232px;
        }
    }
    &__currency {
        position: relative;
        &-name + .header__btn-icon {
            margin-left: 4px;
            margin-right: 0;
            padding: 2px;
        }
        &-list {
            max-height: 120px;
            width: max-content;
        }
        &-item:first-child {
            border-radius: 5px 5px 0 0;
        }
    }
    &__language {
        position: relative;
        .flag {
            transform: scale(0.5);
        }
        &-btn {
            display: flex;
            align-items: center;
        }
        &-name {
            text-transform: uppercase;
            & + .header__btn-icon {
                margin-left: 4px;
                margin-right: 0;
                padding: 2px;
            }
        }
        &-item {
            display: flex;
            .flag {
                transform: scale(0.5) translateX(-25%);
            }                
            &:first-child {
                border-radius: 5px 5px 0 0;
            }
        }
    }
}

.header {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    &.fixed {
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
        background-color: $bgColor;
        z-index: 1000;
    }

    button {
        border: none;
        line-height: 1;
        cursor: pointer;
    }

    &__btn {
        border: none;
        background: transparent;
        color: $primaryColorFont;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        display: flex;
        align-items: center;
        padding: 0;
        transition: all ease 300ms;
        &-icon {
            fill: $primaryColorFont;
            margin-right: 8px;
            transition: all ease 300ms;
        }
        &:hover {
            background: transparent;
            color: $hoverOverButton;
            .header__btn-icon {
                fill: $hoverOverButton;
            }
        }
    }

    &__dropdown {
        position: absolute;
        right: 0;
        // temp z-index
        z-index: 1000;
        background: $bgColor;
        border-radius: 5px;
        box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
        padding: 8px 0;
        &-list {
            overflow-y: auto;
            &::-webkit-scrollbar {
                width: 4px;
                border-radius: 50%;
            }
            &::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 4px transparent;
            }
            &::-webkit-scrollbar-thumb {
                background-color: rgba(#959595, 0.5);
                outline: none;
                border-radius: 2px;
                &:hover{
                    background-color: #959595;
                }
            }
        }
        &-item {
            padding: 10px 16px;
            margin: 0;
            color: $primaryColorFont;
            border: none;
            cursor: pointer;
            transition: all ease 300ms;
            &:hover, &.focused-option-js {
                color: $hoverOverButton;
                background: #F1DDDE;
            }
        }
        &.no-padding {
            padding: 0;
        }
    }

    &__main {
        width: 100%;
        padding-top: 8px;
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        grid-template-rows: repeat(2, fit-content(100%));
        justify-content: flex-start;
        align-items: center;
        &.closed {
            padding-top: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .header-nav {
                width: 100%;
                margin-top: 24px;
                &__list > li:first-child .header-nav__btn {
                    padding-left: 40px;
                }
            }
        }
        &:not(.closed) {
            .header__logo {
                padding-left: 130px;
            }
            .header-client-area {
                padding-right: 130px;
            }
            .header-nav {
                margin-top: 8px;
            }
        }
    }

    &__logo {
        margin-right: 32px;
        grid-row: 1;
        a {
            display:block;
          }
        img {
            height: auto;
            width: auto;
            max-width: 130px;
            max-height: 40px;
            background: $bgColorLogo;
          }
    }

    &__menu {
        display: none;
    }

    &__search {
        margin-right: 32px;
        grid-row: 1;
        width: 100%;
        max-width: 565px;
        border: 1px solid $lightBorderColor;
        border-radius: 5px;
        display: flex;
        align-items: center;
        position: relative;
        &:has(.header__search-input:focus) {
            border: 2px solid $primaryColor;
            .header__search-input::placeholder {
                color: $primaryColor;
            }
        }
        &-input {
            width: 100%;
            padding: 10px 32px 10px 16px;
            border: none;
            &::-webkit-search-cancel-button{
                -webkit-appearance: none;
                display: none;
            }
        }
        &-btn svg {
            fill: $primaryColor;
            box-sizing: content-box;
            padding: 0 8px;
            border-left: 1px solid #F3F3F3;
        }
        &-closer {
            fill: #959595;
            width: 16px;
            height: 16px;
            position: absolute;
            top: 50%;
            right: 50px;
            transform: translateY(-50%);
            cursor: pointer;
            background: $bgColor;
        }
    }

    &__autocomplete{
        width: 100%;
        top: 40px;
        max-height: 290px;
        &-product {
            display: flex;
            align-items: center;
            padding: 8px 16px;
            background: $bgColor;
            color: $primaryColorFont;
            transition: all ease 300ms;
            &-img {
                width: 42px;
                height: 42px;
                position: relative;
                img{
                    max-width: 100%;
                    max-height: 100%;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
            &-names {
                margin-left: 8px;
                flex-grow: 1;
            }
            &-name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: $primaryColor;
                transition: all ease 300ms;
            }
            &-code {
                font-size: 12px;
                color: $bgColorFont;
                transition: all ease 300ms;
            }
            &:hover{
                background: #F1DDDE;
                color: inherit;
            }
        }
    }
    .header-client-area {
        display: flex;
        justify-content: flex-end;
        &__btn-wrapper {
            &.mobile {
                display: none;
            }
            &.cart {
                order: 4;
            }
        }
        &__btn {
            min-width: 106px;
            max-width: 150px;
            width: fit-content;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px 8px 16px;
            color: $primaryColorFont;
            cursor: pointer;
            transition: all ease 300ms;
            &-icon-wrapper {
                margin-top: 14px;
                margin-bottom: 4px;
                width: 100%;
                display: flex;
                align-items: flex-end;
                justify-content: center;
            }
            &-icon {
                position: relative;
                width: 24px;
                height: 24px;
                svg {
                    width: 100%;
                    height: 100%;
                    fill: $headerIconsAndFontColor;
                }
                &.cart-btn {
                    margin-right: 4px;
                    svg {
                        fill: $headerCartIconAndFontColor;
                    }
                    .counter-bg {
                        left: 20px;
                        right: auto;
                    }
                }
            }
            &-text {
                font-size: 11px;
                line-height: 16px;
                font-weight: 500;
                text-align: center;
                color: $headerIconsAndFontColor;
                &.cart {
                    color: $headerCartIconAndFontColor;
                }
                &.mobile {
                    display: none;
                }
            }
            &-price {
                font-size: 10px;
                line-height: 16px;
                color: $headerCartIconAndFontColor;
            }
            .counter-bg {
                position: absolute;
                top: -8px;
                right: -8px;
                display: flex;
                justify-content: center;
                align-items: center;
                min-width: 16px;
                width: auto;
                height: 16px;
                border-radius: 50%;
                background-color: $headerCounterBgColor;
                color: $headerCounterFontColor;
                padding: 4px;
                font-size: 11px;
            }
            &:hover, &.focused-option-js {
                .counter-bg {
                    background-color: $headerCounterBgColorHover;
                    color: $headerCounterFontColorHover;
                }
                .header-client-area__btn {
                    &-icon {
                        svg {
                            fill: $headerIconsAndFontColorHover;
                        }
                        &.cart-btn svg {
                            fill: $headerCartIconAndFontColorHover;
                        }
                    }
                    &-text {
                        color: $headerIconsAndFontColorHover;
                        &.cart {
                            color: $headerCartIconAndFontColorHover;
                        }
                    }
                    &-price {
                        color: $headerCartIconAndFontColorHover;
                    }
                }
            }
        }
    }
    .header-nav {
        grid-column: 1 / 4;
        grid-row: 2;
        background-color: $menuBackgroundColor;
        border-top: 1px solid $menuBorderColor;
        border-bottom: 1px solid $menuBorderColor;
        padding: 0 130px;
        &__list {
            visibility: hidden;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            & > li:first-child .header-nav__btn {
                padding-left: 16px;
                &::before {
                    content: '';
                    display: block;
                    width: 1px;
                    height: 24px;
                    background-color: $menuBorderColor;
                    position: absolute;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                }
            }
            &.visible {
                visibility: visible;
            }
        }
        &__btn {
            position: relative;
            display: flex;
            align-items: center;
            padding: 12px 40px 10px;
            font-weight: 600;
            line-height: 24px;
            color: $menuIconsAndFontColor;
            border-bottom: 2px solid transparent;
            white-space: nowrap;
            cursor: pointer;
            transition: all ease 300ms;
            svg {
                fill: $menuIconsAndFontColor;
            }
            &:hover {
                color: $menuIconsAndFontColorHover;
                border-color: $menuIconsAndFontColorHover;
                svg {
                    fill: $menuIconsAndFontColorHover;
                }
            }
            &::after {
                content: '';
                display: block;
                width: 1px;
                height: 24px;
                background-color: $menuBorderColor;
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
            }
            & > * {
                margin-right: 8px;
                &:last-child {
                    margin-right: 0;
                }
            }
            &.dots {
                padding-left: 16px;
                padding-right: 16px;
                order: 9999;
                svg {
                    margin-right: 0;
                }
                .header-nav__btn {
                    padding: 0;
                    border-color: transparent;
                    &:hover {
                        border-color: transparent;
                    }
                }
            }
        }
        &__dropdown {
            top: 50px;
            width: max-content;
            max-width: 250px;
            .header-nav__list > li:first-child .header-nav__btn::after, .header-nav__list > li:first-child .header-nav__btn::before, 
            .header-nav__btn::after, .header-nav__btn::before {
                display: none;
            }
        }
        &__mobile-icon {
            display: none;
        }
    }

    &__sidebar {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.25);
        opacity: 1;
        transition: all ease 300ms;
        &.hide {
            opacity: 0;
        }
        &.none {
            display: none;
        }
        &-content {
            position: absolute;
            top: 0;
            width: fit-content;
            height: 100%;
            display: flex;
            flex-direction: column;
            background-color: $bgColor;
            transform: translateX(0);
            transition: all ease 500ms;
            &.left {
                left: 0;
                &.hide {
                    transform: translateX(-100%);
                }
            }
            &.right {
                right: 0;
                &.hide {
                    transform: translateX(100%);
                }
            }
        }
        &-header {
            width: 100%;
            display: grid;
            grid-template-columns: auto auto;
            grid-template-rows: auto auto;
            justify-content: space-between;
            background-color: $bgColor;
            padding: 16px 24px;
        }
        &-closer {
            background-color: transparent;
            padding: 0;
            width: fit-content;
            grid-row: 1;
            grid-column: 2;
            justify-self: flex-end;
            svg {
                width: 30px;
                height: 30px;
                padding: 4px;
            }
            &:hover {
                background-color: transparent;
            }
        }
        &-name {
            width: 100%;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: 600;
            line-height: 20px;
        }
        &-icon {
            width: 24px;
            height: 24px;
            padding: 2px;
            margin-right: 8px;
        }
    }

    &__categories-search {
        max-width: 260px;
        margin-right: 0;
        background: $inputsBgColor;
        border-width: 2px;
        &.wide {
            grid-row: 2;
            grid-column: 1 / 3;
            margin-top: 16px;
            max-width: none;
        }
    }

    .header-profile {
        width: fit-content;
        &__content {
            border-top: 1px solid rgba(231, 231, 231, 0.91);
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            overflow-y: overlay;
        }
        &__menu {
            margin: 16px 24px 0;

            .customer-container {
                &-menu {
                    > ul {
                        border: none;
                    }
                }
            }
        }
        &__btn {
            width: 100%;
            padding: 16px 0;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            color: $primaryColorFont;
            text-align: center;
            cursor: pointer;
            button {
                background: transparent;
                color: $primaryColorFont;
                padding: 0;
                font-size: inherit;
                font-weight: inherit;
                line-height: inherit;
            }
        }
    }
}

// header-cart
.header-cart {
    width: fit-content;
    .header__sidebar-header {
        align-items: center;
    }
    &__name-box {
        grid-row: 1;
    }
    &__name {
        display: flex;
        align-items: center;
        &-text {
            font-weight: 600;
            color: $primaryColorFont;
            margin: 0;
        }
        &-input {
            border: 2px solid $lightBorderColor;
            border-radius: 5px;
            padding: 5px 10px;
            font-size: 14px;
            &:focus {
                border: 2px solid $primaryColor;
            }
        }
        svg {
            width: 20px;
            height: 20px;
            padding: 2px;
            cursor: pointer;
            margin-left: 4px;
            transition: all 0.3s;
            &:hover {
                fill: $primaryColor;
            }
        }
    }
    &__change {
        position: relative;
        padding-top: 16px;
        grid-row: 2;
        &-btn {
            display: flex;
            align-items: center;
            background: transparent;
            color: $primaryColor;
            padding: 0;
            cursor: pointer;
            &:hover {
                background: transparent;
                color: $primaryColor;
            }
            svg {
                fill: $primaryColor;
                width: 24px;
                height: 24px;
                padding: 2px;
                margin-right: 4px;
            }
            span {
                font-size: 12px;
                font-weight: 500;
                line-height: 16px;
            }
            .loader {
                width: 24px;
                height: 24px;
                margin: auto 6px;
            }
        }
        &-list {
            position: absolute;
            top: 45px;
            left: 0;
            z-index: 100;
            background: #FFF;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.20);
            width: 210px;
            ul {
                overflow-y: auto;
                border-bottom: 1px solid rgba(231, 231, 231, 0.91);
                &::-webkit-scrollbar {
                    width: 4px;
                    border-radius: 50%;
                }
                &::-webkit-scrollbar-track {
                    -webkit-box-shadow: inset 0 0 4px transparent;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: rgba(#959595, 0.5);
                    outline: none;
                    border-radius: 2px;
                    &:hover{
                        background-color: #959595;
                    }
                }
            }
        }
        &-item {
            padding: 7px 13px;
            margin: 3px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover, &.focused-option-js {
                color: $primaryColor;
            }
            &.new {
                display: flex;
                align-items: center;
                width: 204px;

                svg {
                    width: 20px;
                    height: 20px;
                    fill: $primaryColor;
                    padding: 2px;
                    margin-right: 8px;
                }
                span {
                    font-weight: 600;
                    color: $primaryColor;
                }
            }
        }
    }

    &__content {
        border-top: 1px solid rgba(231, 231, 231, 0.91);
        width: 556px;
        max-width: 100%;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }

    &__list {
        padding: 16px 24px;
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        color: $primaryColorFont;
        flex-grow: 1;
        flex-basis: 0;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 4px;
            border-radius: 50%;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 4px transparent;
        }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(#959595, 0.5);
            outline: none;
            border-radius: 2px;
            &:hover{
                background-color: #959595;
            }
        }
        &-row {
            width: 100%;
            display: flex;
            align-items: center;
            text-align: left;
            padding: 16px 0;
            border-bottom: 1px solid #F1DDDE;
            &.first {
                padding-bottom: 0;
                border-bottom: none;
            }
            &:last-child {
                border-bottom: none;
            }
            &.set-element {
                width: calc(100% - 26px);
                margin-left: 4%;
            }
        }
        &-column {
            display: flex;
            align-items: center;
            padding-right: 16px;
            &.mobile-link {
                display: none;
                color: $primaryColor;
            }
            &.product {
                width: 42%;
                span {
                    color: $primaryColor;
                    max-width: 135px;
                    word-wrap: break-word;
                }
            }
            &.quantity-col {
                width: 31%;
                flex-wrap: wrap;
            }
            &.price {
                width: 23%;
                padding-right: 12px;
                font-weight: 400;
                flex-direction: column;
                align-items: flex-start
            }
            &.delete {
                width: 6%;
                padding-right: 0;
                button {
                    padding: 0;
                    background: transparent;
                    &:hover {
                        background: transparent;
                        svg {
                            fill: $primaryColor;
                        }
                    }
                    svg {
                        width: 20px;
                        height: 20px;
                        fill: $primaryColorFont;
                        transition: all 0.3s;
                    }
                }
            }
            &-row {
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
            }
        }
        &-image {
            border-radius: 4px;
            margin-right: 12px;
            width: 60px;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-shrink: 0;
            img {
                max-width: 60px;
                max-height: 60px;
                width: auto;
                height: auto;
            }
        }
    }

    &__quantity {
        width: 100%;
        max-width: 87px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px;
        border: 1px solid #767676;
        border-radius: 5px;
        input {
            width: 100%;
            max-width: 42px;
            height: 38px;
            border: none;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
        }
        &-minus, &-plus {
            height: 38px;
            padding: 0;
            background: transparent;
            &:hover {
                background: transparent;
                svg {
                    fill: $primaryColor;
                }
            }
            svg {
                width: 14px;
                height: 14px;
                fill: #959595;
            }
            &[disabled], &[disabled]:hover {
                background: transparent;
                border: none;
                svg {
                    fill: rgba(149, 149, 149, 0.5);
                }
            }
        }
        &-unit {
            margin-left: 8px;
        }
    }

    &__column-text.mobile {
        display: none;
    }

    &__summary {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        background-color: #F8F9FA;
        border-top: 1px solid rgba(231, 231, 231, 0.91);
        padding: 16px 24px;
        &-column {
            width: calc(50% - 8px);
        }
        &-row {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            font-size: 12px;
            line-height: 16px;
            &.bold {
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
            }
            span {
                width: 50%;
                &:last-child {
                    text-align: left;
                }
            }
        }
        &-btn {
            width: 100%;
            display: block;
            margin-bottom: 8px;
        }
    }

    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        &-img {
            fill: #D5D5D5;
            width: 135px;
            height: 135px;
            margin: 40px auto;
        }
        &-text {
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            text-align: center;
            color: $secondaryColorFont;
        }
    }
}

.header-categories {
    position: relative;
    width: 360px;
    background-color: $categoriesLinksBg;
    flex-grow: 1;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 4px;
        border-radius: 50%;
    }

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 4px transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(#959595, 0.5);
        outline: none;
        border-radius: 2px;

        &:hover {
            background-color: #959595;
        }
    }

    &__sliding {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }

    &__item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        cursor: pointer;

        &:hover {
            background-color: #F8F9FA;
        }

        &.back {
            justify-content: flex-start;
            padding: 16px 24px;
            align-items: baseline;
            cursor: auto;

            button {
                padding: 0;
                padding-left: 4px;
            }
        }

        &.title {
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            padding: 8px 24px;
            cursor: auto;

            &:hover {
                background-color: transparent;
            }
        }

        a {
            &:focus-visible {
                outline-offset: -2px !important;
            }
        }
    }

    &__link {
        display: block;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-align: left;
        color: $primaryColorFont;
        padding: 8px 24px;
        width: 100%;
        transition: all 0.3s;

        &:hover {
            color: $primaryColor;
        }
    }

    &__arrow {
        background: transparent;
        padding: 8px 24px;
        transition: all 0.3s;

        &:hover {
            background: transparent;
        }

        svg {
            fill: $primaryColorFont;
            width: 20px;
            height: 20px;
            transform: rotate(-90deg);

            &:hover {
                fill: $primaryColor;
            }
        }
    }

    &__btn {
        display: flex;
        align-items: center;
        background-color: transparent;
        color: $primaryColorFont;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        cursor: pointer;

        svg {
            fill: $primaryColorFont;
            width: 20px;
            height: 20px;
            padding: 3px;
            margin-right: 5px;
            transform: rotate(90deg);
        }

        &:hover {
            background-color: transparent;
            color: $primaryColor;

            svg {
                fill: $primaryColor;
            }
        }

        &.menu {
            display: none;
        }

        &.primary-color {
            color: $primaryColor;
        }

        &.not-bold {
            font-weight: 400;
        }
    }
}
`